const wall_images = {
  school_hub: require("../../assets/wall/school-hub.svg"),
  my_class: require("../../assets/wall/my-class.svg"),
  my_space: require("../../assets/wall/my-space.svg"),
  clap: require("../../assets/wall/clap.svg"),
  clapGif: require("../../assets/wall/clapGif.gif"),
  comment: require("../../assets/wall/comments.svg"),
  challenge: require("../../assets/wall/cup.svg"),
  sort: require("../../assets/wall/sort.svg"),
  back_arrow: require("../../assets/wall/arrow-left.svg"),
  settings: require("../../assets/wall/Settings.svg"),
  more: require("../../assets/wall/more.svg"),
  plus: require("../../assets/wall/add-circle.svg"),
  pdf: require("../../assets/wall/pdf.svg"),
  ppt: require("../../assets/wall/ppt.svg"),
  doc: require("../../assets/wall/doc.svg"),
  xls: require("../../assets/wall/xls.svg"),
  img: require("../../assets/wall/img_icon.svg"),
  gallery: require("../../assets/wall/gallery.svg"),
  video_icon: require("../../assets/wall/video-icon.svg"),
  left_arrow: require("../../assets/wall/arrow-circle-left.svg"),
  right_arrow: require("../../assets/wall/arrow-circle-right.svg"),
  camera: require("../../assets/wall/camera.svg"),
  mic: require("../../assets/wall/mic.svg"),
  note: require("../../assets/wall/note.svg"),
  chat: require("../../assets/wall/chat.svg"),
  postSuccess: require("../../assets/wall/postSuccess.gif"),
  eye: require("../../assets/wall/eye.svg"),
  vin: require("../../assets/wall/Vin.svg"),
  emoji: require("../../assets/wall/emoji.svg"),
  send: require("../../assets/wall/send.svg"),
  activeClap: require("../../assets/wall/clap_active.svg"),
  edit: require("../../assets/wall/edit.svg"),
  hide: require("../../assets/wall/hide.svg"),
  delete: require("../../assets/wall/delete.svg"),
  deleteGif: require("../../assets/wall/delete.gif"),
  appriciate: require("../../assets/wall/appriciate.svg"),
  suggestPortifolio: require("../../assets/wall/suggest_portifolio.svg"),
  report: require("../../assets/wall/report.svg"),
  hidden: require("../../assets/wall/hidden.png"),
  vote: require("../../assets/wall/vote.svg"),
  activeVote: require("../../assets/wall/vote_active.svg"),
  voteGif: require("../../assets/wall/voteGif.gif"),
  voteExaustedGif: require("../../assets/wall/voteExhausted.png"),
  portifolio: require("../../assets/wall/porfolio.svg"),
  background: {
    image1: require("../../assets/wall/background/bgOne.svg"),
    bgOne: require("../../assets/wall/wall_bg.svg"),
  },
  bell: require("../../assets/home/bell.svg"),
  checklist: require("../../assets/home/checklist.svg"),
  clock: require("../../assets/home/clock.svg"),
  learn: require("../../assets/bottom-nav/learn.svg"),
  task: require("../../assets/bottom-nav/task.svg"),
  assessment: require("../../assets/bottom-nav/assessment.svg"),
  experiential: require("../../assets/home/experiential.svg"),
  close: require("../../assets/home/close.svg"),
  doubt: require("../../assets/bottom-nav/doubt.svg"),
  addChapter: require("../../assets/bottom-nav/addChapter.svg"),
  addTopic: require("../../assets/bottom-nav/addTopic.svg"),
  outstandingLottie: require("../../assets/wall/outstanding.json"),
  experientialWelcome: require("../../assets/wall/experientialWelcome.json"),
  experientialDelete: require("../../assets/wall/experientialDelete.json"),
  letsGetStarted: require("../../assets/wall/LetsGetStarted.json"),
  experientialLoading: require("../../assets/wall/experientialLoading.json"),
  tasksBold: require("../../assets/bottom-nav/Tasks-bold.svg"),
  schoolUpdatesBold: require("../../assets/bottom-nav/school-updates-bold.svg"),
  syllabusBold: require("../../assets/bottom-nav/Syllabus-bold.svg"),
  tasksNormal: require("../../assets/bottom-nav/Tasks-line.svg"),
  schoolUpdatesNormal: require("../../assets/bottom-nav/school-updates-line.svg"),
  syllabusNormal: require("../../assets/bottom-nav/Syllabus-line.svg"),
  tasksOutline: require("../../assets/bottom-nav/Tasks-outline.svg"),
  schoolUpdatesOutline: require("../../assets/bottom-nav/school-updates-outline.svg"),
  syllabusOutline: require("../../assets/bottom-nav/Syllabus-outline.svg"),
};

export default wall_images;
